/* Anna & Klara — strona główna: reveal on scroll (.rev-up).
   Jedyny motion na stronie. Uszanuj prefers-reduced-motion (CSS wyłącza transity). */
(function () {
  function init() {
    var els = document.querySelectorAll('.rev-up:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (x.isIntersecting) {
          x.target.classList.add('in');
          io.unobserve(x.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init po edycji w theme editorze (sekcje przeładowywane dynamicznie).
  document.addEventListener('shopify:section:load', init);
})();
